import japaneseMessages from '@bicstone/ra-language-japanese'
import { TranslationMessages } from 'react-admin'

const customJapaneseMessages: TranslationMessages = {
  ...japaneseMessages,
  ra: {
    ...japaneseMessages.ra,
    action: {
      ...japaneseMessages.ra?.action,
      clear: 'クリア',
      reset: 'リセット',
    },
  },
  pos: {
    app_title: '獣医ポータル',
    login: {
      title: 'adapet.ai にログイン',
      forgot_password: 'パスワードをお忘れですか？',
      no_account: 'アカウントをお持ちでない方は',
      sign_up: '新規登録',
      or: 'または',
      continue_microsoft: 'Microsoft で続行',
    },
    shared_with_me: {
      load_failed: '共有データの読み込みに失敗しました。後でもう一度お試しください。',
      empty_title: '共有されているペットはありません',
      empty_subtitle: '他の獣医がペットを共有すると、ここに表示されます。',
      shared_by: '共有者：%{name}',
      all_pets: 'すべてのペット',
      specific_pets: '%{count} 匹の指定ペット',
      you_can: '可能な操作：%{permissions}',
      shared_at: '共有日：%{date}',
      expires_at: '有効期限：%{date}',
      shared_pets_label: '共有ペット：',
      view_pet: 'ペットを表示',
      pet_meta: '%{species} • 飼い主：%{owner}',
      all_pets_message: '%{name} の顧客のすべてのペットにアクセスできます。',
      permissions: {
        view_metrics: 'メトリクス閲覧',
        view_emrs: 'カルテ閲覧',
        add_activities: 'アクティビティ追加',
        add_emr_notes: 'メモ追加',
      },
    },
    consent: {
      loading: '同意リクエストを読み込み中...',
      title: 'グループメンバーシップリクエスト',
      title_with_count: 'グループメンバーシップリクエスト (%{count})',
      no_pending: '保留中のグループメンバーシップリクエストはありません。',
      pending_warning: '同意が必要な保留中のグループメンバーシップリクエストがあります。',
      pending_chip: '保留中',
      accept: '承諾',
      decline: '拒否',
      cancel: 'キャンセル',
      invited_by: '招待者：%{name} (%{email})',
      invited_on: '招待日：%{date}',
      accept_dialog_title: 'グループメンバーシップを承諾',
      decline_dialog_title: 'グループメンバーシップを拒否',
      accept_question: '"%{group}" グループに参加しますか？',
      decline_question: '"%{group}" への招待を拒否してよろしいですか？',
      accept_warning:
        '承諾すると、ペットデータがグループの他のメンバーと共有され、共同監視が可能になります。',
      notes_label: 'メモ（任意）',
      accept_notes_placeholder: 'このグループ参加に関するメモを追加...',
      decline_notes_placeholder: '拒否の理由を追加（任意）...',
      load_failed: '同意リクエストの読み込みに失敗しました',
      update_failed: '同意の更新に失敗しました',
    },
    auth: {
      login: {
        email_not_verified:
          'ログインする前にメールアドレスの確認をお願いします。受信トレイの確認リンクをご確認ください。',
        invalid_credentials: 'メールアドレスまたはパスワードが正しくありません。',
        account_locked:
          'ログイン試行回数が多すぎるため、アカウントは一時的にロックされています。しばらくしてから再度お試しください。',
        role_not_allowed:
          'このアカウントは獣医師ポータルにアクセスできません。ペットの飼い主の方はAdapet Medicalモバイルアプリをご利用ください。',
        generic_error: 'ログインに失敗しました。再度お試しください。',
        oauth_failed:
          'そのプロバイダーでのサインインに失敗しました。再度お試しいただくか、メールとパスワードをご利用ください。',
      },
      forgot_password: {
        title: 'パスワードをお忘れの方',
        description:
          'メールアドレスを入力してください。パスワードリセット用のリンクをお送りします。',
        email_label: 'メールアドレス',
        sending: '送信中...',
        send_button: 'リセットメールを送信',
        back_to_login: 'ログインに戻る',
        success: 'パスワードリセットメールを送信しました。受信トレイをご確認ください。',
        email_required: 'メールアドレスは必須です',
        send_failed: 'リセットメールの送信に失敗しました',
        connection_error: 'サーバーに接続できません。後でもう一度お試しください。',
      },
      reset_password: {
        title: 'パスワードをリセット',
        invalid_link_title: '無効なリセットリンク',
        invalid_link_message: 'このパスワードリセットリンクは無効または期限切れです。',
        request_new: '新しいリセットリンクを要求',
        new_password_label: '新しいパスワード',
        confirm_password_label: '新しいパスワードを確認',
        resetting: 'リセット中...',
        reset_button: 'パスワードをリセット',
        success: 'パスワードがリセットされました。ログイン画面に移動します...',
        invalid_request: '無効なリクエストです。新しいリセットリンクを要求してください。',
        reset_failed: 'パスワードのリセットに失敗しました。リンクが期限切れの可能性があります。',
        network_error: 'ネットワークエラーが発生しました。再試行してください。',
        password_required: 'パスワードは必須です',
        passwords_dont_match: 'パスワードが一致しません',
      },
    },
    search: '検索',
    configuration: '設定',
    language: '言語',
    action: {
      change_theme: 'テーマの変更',
    },
    theme: {
      name: 'テーマ',
      light: 'ライト',
      dark: 'ダーク',
    },
    dashboard: {
      title: 'ダッシュボード',
      welcome_subtitle: 'Adapet Medical へようこそ。今日の最新情報をご覧ください。',
      active_patient_context: 'アクティブな患者：',
      pet_id_label: 'ペット ID：%{id}',
      no_patient_selected: '患者未選択（システムビュー）',
      pets_section: 'ペット',
      devices_section: 'デバイス',
      monthly_revenue: '月間収入',
      month_history: '30日間の収入推移',
      new_orders: '新規注文',
      pending_emrs: '未処理カルテ',
      all_emrs: 'すべてのカルテを表示',
      new_customers: '新規顧客',
      all_customers: 'すべての顧客を表示',
      pending_orders: '保留中の注文',
      current_selected_pet: '現在選択中のペット：',
      recently_updated: '最近の更新',
      generate_report: 'レポート生成',
      glucose_report: '血糖レポート',
      glucose_trend: '血糖トレンド',
      daily_tir: '日別 TIR',
      daily_trends_and_activities: '日別血糖トレンドとアクティビティ',
      simple_view: 'シンプル表示',
      full_report: '完全レポート',
      print_report: 'レポート印刷',
      no_data: 'N/A',
      activity_logs: 'アクティビティログ',
      log_event_prompt:
        '＋ イベント記録をクリックして、インスリン・食事・運動のアクティビティを記録',
      date_range_navigation: '日付範囲ナビゲーション',
      clinical_notes: '臨床ノート',
      add_note_description: 'このペットのノートを追加します。PDFレポートに含まれます。',
      portal_view: 'ポータル表示',
      no_device_selected: 'このペットに利用可能なデバイスがありません',
      no_devices: 'このペットのデバイスが見つかりません',
      search_pets: 'オーナー、ペット名、IDで検索...',
      error_loading_data: 'データの読み込みエラー',
      no_data_available: 'データがありません',
      order: {
        items: '%{customer_name} による注文、1 点 |||| %{customer_name} による注文、%{nb_items} 点',
      },
      welcome: {
        title: '獣医血糖モニタリングシステムへようこそ',
        subtitle:
          'これはペットの血糖モニタリング管理システムです。自由にデータを閲覧・編集できます。',
        ra_button: 'react-admin サイト',
        demo_button: 'デモのソースコード',
      },
    },
    help: {
      menu_title: 'ヘルプ＆サポート',
      page_title: 'VetPo ヘルプセンター',
      title: 'ヘルプ＆サポート',
      welcome_message:
        'VetPoヘルプセンターへようこそ。ガイド、チュートリアル、サポートリソースを活用して、血糖モニタリングシステムを最大限にご利用ください。',
      current_language: '現在の言語',
      user_guides: 'ユーザーガイド',
      user_guides_desc: 'VetPoを効果的に操作・利用するための包括的なガイドです。',
      quick_start: 'クイックスタートガイド',
      quick_start_desc: 'VetPoシステムの基本と操作方法をご案内します。',
      features_guide: '機能ガイド',
      features_guide_desc: 'VetPoの全機能と機能の完全な概要です。',
      reading_tables: 'データテーブルの読み方',
      reading_tables_desc: 'データテーブルと品質指標の解釈方法を学びます。',
      understanding_charts: 'チャートの理解',
      understanding_charts_desc: '血糖トレンドチャートと分析の可視化をマスターします。',
      faq: 'よくある質問',
      faq_desc: 'よくある質問とトラブルシューティングの解決策です。',
      open_guide: 'ガイドを開く',
      quick_reference: 'クイックリファレンス',
      quick_ref: {
        navigation: '基本ナビゲーション',
        navigation_desc: 'サイドバーメニューを使って各セクションにアクセス',
        pet_selection: 'ペット選択',
        pet_selection_desc: 'ダッシュボードでペットをクリックしてモニタリングを開始',
        glucose_monitoring: '血糖モニタリング',
        glucose_monitoring_desc: 'チャートでリアルタイムデータとトレンドを表示',
      },
      support_contact: 'サポート＆お問い合わせ',
      support_desc: '必要な時にサポートを受けられます。',
      support: {
        email: 'メールサポート',
        email_desc: 'support@adapetmedical.com - 24時間以内に返信',
        chat: 'ライブチャット',
        chat_desc: '営業時間内にご利用いただけます',
        phone: '電話サポート',
        phone_desc: '1-888-444-2618 - 緊急時のサポート',
        chat_available:
          'ライブチャットをご利用いただけます。画面右下のチャットアイコンをご確認ください。',
      },
      contact: 'お問い合わせ',
      emergency_notice_title: '緊急時のお知らせ',
      emergency_notice_desc:
        '緊急の獣医療が必要な場合は、システムデータよりも直接的な臨床評価を常に優先してください。VetPoはモニタリングツールを提供しますが、専門的な獣医の判断に代わるものではありません。',
    },
    users: {
      promote_success: '%{email} をグループ管理者に昇格しました',
      promote_confirm: '%{email} をグループ管理者 (vetadmin) に昇格しますか？',
      promote_failed: 'ユーザーの昇格に失敗しました',
      manage_users: 'ユーザー管理',
      promote_button: 'グループ管理者に昇格',
      role_vet: '獣医師',
      role_vetadmin: 'グループ管理者',
      role_admin: 'システム管理者',
      role_siteadmin: 'サイト管理者',
      role_cms: 'コンテンツ管理者',
      role_user: 'ペットオーナー',
      current_language: '現在の言語',
      user_guides: 'ユーザーガイド',
      user_guides_desc: 'VetPoを効果的に操作・利用するための包括的なガイドです。',
      quick_start: 'クイックスタートガイド',
      quick_start_desc: 'VetPoシステムの基本と操作方法をご案内します。',
      features_guide: '機能ガイド',
      features_guide_desc: 'VetPoの全機能と機能の完全な概要です。',
      reading_tables: 'データテーブルの読み方',
      reading_tables_desc: 'データテーブルと品質指標の解釈方法を学びます。',
      understanding_charts: 'チャートの理解',
      understanding_charts_desc: '血糖トレンドチャートと分析の可視化をマスターします。',
      faq: 'よくある質問',
      faq_desc: 'よくある質問とトラブルシューティングの解決策です。',
      open_guide: 'ガイドを開く',
      quick_reference: 'クイックリファレンス',
      quick_ref: {
        navigation: '基本ナビゲーション',
        navigation_desc: 'サイドバーメニューを使って各セクションにアクセス',
        pet_selection: 'ペット選択',
        pet_selection_desc: 'ダッシュボードでペットをクリックしてモニタリングを開始',
        glucose_monitoring: '血糖モニタリング',
        glucose_monitoring_desc: 'チャートでリアルタイムデータとトレンドを表示',
      },
      support_contact: 'サポート＆お問い合わせ',
      support_desc: '必要な時にサポートを受けられます。',
      support: {
        email: 'メールサポート',
        email_desc: 'support@adapetmedical.com - 24時間以内に返信',
        chat: 'ライブチャット',
        chat_desc: '営業時間内にご利用いただけます',
        phone: '電話サポート',
        phone_desc: '1-888-444-2618 - 緊急時のサポート',
        chat_available:
          'ライブチャットをご利用いただけます。画面右下のチャットアイコンをご確認ください。',
      },
      contact: 'お問い合わせ',
      emergency_notice_title: '緊急時のお知らせ',
      emergency_notice_desc:
        '緊急の獣医療が必要な場合は、システムデータよりも直接的な臨床評価を常に優先してください。VetPoはモニタリングツールを提供しますが、専門的な獣医の判断に代わるものではありません。',
    },
    chat: {
      title: 'ライブサポート',
      welcome_message:
        'こんにちは！本日はどのようにお手伝いできますか？VetPoの機能、血糖モニタリング、技術的な問題についてお気軽にご質問ください。',
      input_placeholder: 'メッセージを入力...',
      send: '送信',
      typing: 'サポートが入力中',
      status_online: 'オンライン',
      status_offline: 'オフライン',
      powered_by: 'VetPo サポート提供',
      error_general: '申し訳ありません、エラーが発生しました。もう一度お試しください。',
      error_network: 'ネットワークエラーです。接続を確認して、もう一度お試しください。',
      minimize: '最小化',
      close: 'チャットを閉じる',
      unread_indicator: '新着メッセージ',
    },
    client_profile: {
      edit_client: 'クライアントを編集',
      dialog_title: 'クライアント情報の編集',
      save: '保存',
      saved: 'クライアント情報を更新しました。',
      save_error: 'クライアントを更新できませんでした。もう一度お試しください。',
      not_allowed: 'このクライアントを編集する権限がありません。',
      name_too_short: 'クライアント名は2文字以上必要です。',
      read_only_hint: 'このクライアントに紐づく病院のみが情報を編集できます。',
    },
    pet_edit: {
      pet_information: 'ペット情報',
      basic_details_readonly: '基本ペット情報（読み取り専用）',
      basic_details_editable: '基本ペット情報（獣医師編集可能）',
      owner_name: 'オーナー名',
      editable_fields: '編集可能フィールド',
      vet_modifiable_fields: '獣医師が変更可能なフィールド',
      auto_save: {
        saving: '保存中...',
        saved: 'ペット情報を保存しました',
        error: 'ペット情報の保存に失敗しました',
        unsaved_changes: '未保存の変更があります',
        last_saved: '最終保存：%{time}',
      },
    },
    alert_rules: {
      title: '血糖アラートルール',
      glucose_range: '血糖範囲',
      pending_sync: '同期待ち',
      unsaved_changes: '未保存の変更',
      configuration_desc: 'このペットの血糖モニタリング閾値とアラート条件を設定します',
      configuration_info:
        'このペットのカスタム血糖閾値を設定します。ペットの血糖範囲は低血糖閾値（mmol/L）から自動的に算出されます。血糖値がこれらの閾値を超えるとアラートがトリガーされます。',
      add_rule_tooltip: '新しいアラートルールを追加',
      save_rules: 'ルールを保存',
      saving: '保存中...',
      loading: 'アラートルールを読み込み中...',
      no_rules_configured:
        'アラートルールが設定されていません。「ルール追加」をクリックして、このペットの血糖モニタリングルールを作成してください。',
      rule_types: {
        critical_hypoglycemia: '重度低血糖',
        warning_hypoglycemia: '警告低血糖',
        critical_hyperglycemia: '重度高血糖',
        warning_hyperglycemia: '警告高血糖',
        rapid_drop: '急速低下',
        dawn_pattern: '暁現象',
        somogyi_pattern: 'Somogyi現象',
        postprandial_spikes: '食後血糖スパイク',
      },
      thresholds: {
        critical_threshold: '重度閾値',
        warning_threshold: '警告閾値',
        hyperglycemia_threshold: '高血糖閾値',
        severe_hyperglycemia_threshold: '重症高血糖閾値',
        somogyi_rebound_threshold: 'Somogyiリバウンド閾値',
        dawn_elevation_threshold: '暁現象上昇閾値',
        drop_threshold: '低下閾値',
        analysis_window: '分析ウィンドウ（時間）',
        postprandial_spike_threshold: '食後スパイク閾値',
        severe_spike_threshold: '重度スパイク閾値',
        postprandial_window_hours: '食後モニタリングウィンドウ（時間）',
        pre_meal_window_hours: '食前ベースラインウィンドウ（時間）',
      },
      fields: {
        rule_type: 'ルールタイプ',
        unit: '単位',
        trigger_count: 'トリガー回数',
        trigger_count_helper: '読み取り専用の使用回数',
        notes: '備考',
        notes_placeholder: 'このルールに関する簡単な説明または備考',
        active: '有効',
        active_status: '有効',
        inactive_status: '無効',
        email_notifications: 'メール通知',
        sms_notifications: 'SMS通知',
      },
      notification_settings: '通知設定',
      delete_rule_tooltip: 'このルールを削除',
      add_rule: 'ルール追加',
      save: '保存',
      auto_saving: '自動保存中...',
      all_rule_types_added: 'すべてのルールタイプが追加済みです',
      help_text: {
        critical_hypoglycemia:
          '血糖値がこの閾値を下回った場合に重度アラートをトリガーします。即座の対処が必要です。',
        warning_hypoglycemia:
          '血糖値がこの閾値を下回った場合に警告アラートをトリガーします。モニタリングが必要です。',
        critical_hyperglycemia:
          '血糖値がこの閾値を超えた場合に重度アラートをトリガーします。ケトアシドーシスのリスクがあります。',
        warning_hyperglycemia:
          '血糖値がこの閾値を超えた場合に警告アラートをトリガーします。モニタリングが必要です。',
        rapid_drop:
          '指定された速度で血糖値が低下した場合にアラートをトリガーします。急速低下閾値を検出に使用し、警告閾値を低血糖モニタリングに使用します。',
        dawn_pattern:
          '朝の血糖上昇パターンを検出します。指定された時間ウィンドウ内のデータを分析します。',
        somogyi_pattern:
          '低血糖エピソード後のリバウンド高血糖を検出します。パターン検出に分析ウィンドウが必要です。',
        postprandial_spikes:
          '食後血糖と食前ベースラインを比較して、食後の血糖スパイクを検出します。',
      },
      somogyi_note:
        '注意：夜間低血糖閾値は、既存の重度低血糖または警告低血糖ルールから自動的に決定されます。夜間の低閾値（午後10時～午前6時）を設定するには、それらのルールを個別に設定してください。',
      help_ranges: {
        critical_threshold: '範囲：1.0-4.0 mmol/L。2.8 mmol/L未満は生命の危険があります。',
        warning_threshold: '範囲：3.0-5.5 mmol/L。重度閾値より高い値である必要があります。',
        hyperglycemia_threshold: '範囲：8.0-25.0 mmol/L。重症閾値より低い値である必要があります。',
        severe_hyperglycemia_threshold:
          '範囲：12.0-30.0 mmol/L。16.0以上でケトアシドーシスのリスクがあります。',
        somogyi_rebound_threshold: '範囲：6.0-20.0 mmol/L。朝のリバウンド血糖レベル。',
        dawn_elevation_threshold: '範囲：5.0-15.0 mmol/L。自然な朝の血糖上昇。',
        rapid_drop_threshold:
          '範囲：1.0-5.0 mmol/L（15分あたり）。急速低下アラートをトリガーする血糖低下速度。アルゴリズムは過去30分間のデータを分析します。',
        analysis_window: '範囲：12-72時間。パターン分析の時間帯。',
        postprandial_spike_threshold:
          '範囲：3.0-10.0 mmol/L。ベースラインからのカスタムスパイク閾値。',
        severe_spike_threshold: '範囲：5.0-15.0 mmol/L。重度スパイクのより高い閾値。',
        postprandial_window_hours:
          '範囲：2.0-6.0時間。食後のスパイクをモニタリングする時間ウィンドウ。',
        pre_meal_window_hours: '範囲：0.5-3.0時間。食前ベースライン算出の時間ウィンドウ。',
      },
      metadata: {
        last_triggered: '最終トリガー',
        total_triggers: '合計トリガー回数',
      },
      notifications: {
        saved_successfully: 'アラートルールを保存しました',
        saved_locally: 'アラートルールをローカルに保存しました（サーバー接続不可）',
        could_not_load: 'アラートルールを読み込めませんでした。デフォルト値を使用します。',
        glucose_range_stored:
          '血糖範囲を算出しローカルに保存しました（サーバーが利用できない可能性があります）',
        glucose_range_synced: '血糖範囲をサーバーと同期しました',
      },
      validation: {
        required: 'この項目は必須です',
        out_of_range: '値は {min} から {max} {unit} の範囲内である必要があります',
        critical_threshold:
          '重度閾値は 1.0 から 4.0 mmol/L (18-72 mg/dL) の範囲内である必要があります',
        warning_threshold:
          '警告閾値は 3.0 から 5.5 mmol/L (54-99 mg/dL) の範囲内である必要があります',
        hyperglycemia_threshold:
          '高血糖閾値は 8.0 から 25.0 mmol/L (144-450 mg/dL) の範囲内である必要があります',
        severe_hyperglycemia_threshold:
          '重症高血糖閾値は 12.0 から 30.0 mmol/L (216-540 mg/dL) の範囲内である必要があります',
        somogyi_rebound_threshold:
          'Somogyiリバウンド閾値は 6.0 から 20.0 mmol/L (108-360 mg/dL) の範囲内である必要があります',
        dawn_elevation_threshold:
          '暁現象上昇閾値は 5.0 から 15.0 mmol/L (90-270 mg/dL) の範囲内である必要があります',
        rapid_drop_threshold:
          '急速低下閾値は 1.0 から 5.0 mmol/L (18-90 mg/dL)（15分あたり）の範囲内である必要があります',
        postprandial_spike_threshold:
          '食後スパイク閾値は 3.0 から 10.0 mmol/L (54-180 mg/dL) の範囲内である必要があります',
        severe_spike_threshold:
          '重度スパイク閾値は 5.0 から 15.0 mmol/L (90-270 mg/dL) の範囲内である必要があります',
        postprandial_window_hours: '食後ウィンドウは 2.0 から 6.0 時間の範囲内である必要があります',
        pre_meal_window_hours: '食前ウィンドウは 0.5 から 3.0 時間の範囲内である必要があります',
        analysis_window: '分析ウィンドウは 12 から 72 時間の範囲内である必要があります',
        cannot_save_with_errors: '保存できません：保存前にバリデーションエラーを修正してください',
      },
    },
    alerts: {
      title: 'アラート',
      total: '合計',
      no_alerts: '現在のフィルター条件に一致するアラートはありません',
      alert_context: 'アラートコンテキスト',
      recommendations: '推奨事項',
      details: '詳細',
      acknowledge: '確認',
      acknowledged: '確認済み',
      active: 'アクティブ',
      resolved: '解決済み',
      dismissed: '却下済み',
      unacknowledged_count: '%{count} 件未確認',
      refresh_tooltip: 'アラートを更新',
      monitoring_issue: 'アラートモニタリングの問題',
      monitoring_issue_retry:
        'アラートが正しく表示されていない可能性があります。更新をクリックして再試行してください。',
      no_recent_alerts: '最近のアラートはありません',
      checking_interval: '%{minutes} 分ごとにアラートを確認',
      acknowledged_at: '確認済み：%{time}',
      acknowledge_success: 'アラートの確認に成功しました',
      acknowledge_failed: 'アラートの確認に失敗しました',
      acknowledge_tooltip: 'アラートを確認',
      show_details: '詳細を表示',
      pet_alerts: 'ペット %{petId} のアラート',
      all_pets: 'すべてのペット',
      showing_count: '%{total} 件中 %{shown} 件を表示',
      critical_require_attention: '%{count} 件の重度アラートが即座の対応を必要としています',
      critical_alerts_count: '%{count} 件の重度アラート',
      active_alerts_count: '%{count} 件のアクティブアラート',
      navigate_cannot: 'ナビゲーションできません：このアラートのペットIDが見つかりません',
      filter: {
        severity: '重症度',
        type: 'タイプ',
        status: 'ステータス',
        all: 'すべて',
        hypoglycemia: '低血糖',
        hyperglycemia: '高血糖',
        somogyi: 'Somogyi',
        trend: 'トレンド',
      },
      type: {
        hypoglycemia: '低血糖',
        critical_hypoglycemia: '重度低血糖',
        hyperglycemia: '高血糖',
        rapid_drop: '急速低下',
        pattern_detected: 'パターン',
        somogyi: 'Somogyi現象',
        sensor_failure: 'センサー問題',
        trend: 'トレンド分析',
        trend_analysis: 'トレンド分析',
        system: 'システムアラート',
      },
      severity: {
        critical: '重度',
        high: '高',
        medium: '中',
        low: '低',
      },
      messages: {
        critical_attention: '件の重度アラートが即座の対応を必要としています',
        hypoglycemia_detected: '低血糖を検出 - 血糖値が安全範囲を下回っています',
        hyperglycemia_detected: '高血糖を検出 - 血糖値が目標範囲を超えています',
        somogyi_detected: 'AI分析によりSomogyi現象パターンを検出しました',
        trend_analysis_available: '新しい血糖トレンド分析が利用可能です',
      },
      configuration: {
        title: 'アラート設定',
        description: 'AIアラート閾値と検出パラメータを設定',
        hypoglycemia_section: '低血糖検出',
        hyperglycemia_section: '高血糖検出',
        somogyi_section: 'Somogyi現象検出',
        trend_analysis_section: 'AIトレンド分析',
        custom_rules_section: 'カスタムアラートルール',
        save_config: '設定を保存',
        reset_config: 'デフォルトにリセット',
        apply_preset: 'プリセットを適用',
        presets: {
          conservative: '慎重型（高感度）',
          standard: '標準型（バランス）',
          aggressive: '積極型（低感度）',
        },
      },
      thresholds: {
        critical_threshold: '重度閾値',
        high_threshold: '高優先度閾値',
        medium_threshold: '中優先度閾値',
        confidence_threshold: '最小信頼度',
        rebound_magnitude: '最小リバウンド幅',
      },
      notifications: {
        email_sent: 'メール通知を送信しました',
        push_sent: 'プッシュ通知を送信しました',
        dashboard_updated: 'ダッシュボード通知を作成しました',
        vet_warning_sent: '獣医師への警告を送信しました',
        daily_report_sent: '日次レポートを送信しました',
      },
      reports: {
        daily_report: '日次アラートレポート',
        summary_title: 'アラートサマリー',
        glucose_summary: '血糖サマリー',
        patterns_detected: '検出されたパターン',
        ai_recommendations: 'AI推奨事項',
        report_period: 'レポート期間',
        total_readings: '総測定回数',
        time_in_range: '目標範囲内時間',
        episodes_count: 'エピソード数',
        generate_report: 'レポート生成',
        download_report: 'レポートダウンロード',
        email_report: 'メールレポート',
      },
    },
    menu: {
      section_patients: 'æ£è',
      section_sharing: 'ã³ã©ãã¬ã¼ã·ã§ã³',
      section_admin: 'ç®¡ç',
      clinic_teams: 'ã¯ãªããã¯ãã¼ã ',
      all_teams_readonly: 'å¨ãã¼ã ï¼èª­ã¿åãå°ç¨ï¼',
      manage_users: 'ã¦ã¼ã¶ã¼ç®¡ç',
      my_account: 'ãã¤ã¢ã«ã¦ã³ã',
      pet_shares_hint: 'ç¹å®ã®ãããï¼ã¾ãã¯ãã¹ã¦ã®ãããï¼ãä»ã®ç£å»å¸«ã¨å±æããå±æãããããããç¢ºèªã§ãã¾ãã',
      sales: '売上',
      catalog: 'カタログ',
      customers: '顧客',
    },
    events: {
      review: {
        title: '「%{product}」にレビューを投稿',
      },
      order: {
        title: '1 点を注文 |||| %{smart_count} 点を注文',
      },
    },
    export: {
      button: 'エクスポート',
      pdf: 'PDFとしてエクスポート',
      image: '画像としてエクスポート',
    },
    glucose: {
      no_devices_found: 'このペットの血糖モニタリングデバイスが見つかりません。',
      trend_over_time: '血糖トレンドの推移',
      statistics_range: '血糖統計＆範囲分析',
      time_in_range_analysis: '目標範囲内時間分析',
      no_data_available: 'データがありません',
      event_band: 'アクティビティイベントタイムライン',
      view_day: '日',
      view_week: '週',
      view_month: '月',
      reset_view: '表示をリセット',
      reset_group: 'グループをリセット',
      reset_selection: '選択をリセット',
      select_date: '日付を選択',
      start_date: '開始日',
      end_date: '終了日',
      date_range: '日付範囲',
      single_date: '単日',
      filter_date_range: '日付範囲フィルター',
      available_range: '利用可能範囲',
      configure_target_range: '目標範囲の設定',
      show_activity_markers: 'アクティビティマーカーを表示',
      hide_activity_markers: 'アクティビティマーカーを非表示',
      target_range_settings: '目標範囲設定',
      target_low: '目標下限',
      target_high: '目標上限',
      current_unit: '現在の単位',
      out_of_range: '範囲外',
      target_range_preview: 'プレビュー',
      loading_stats: '統計データを読み込み中...',
      error_loading_stats: '統計データの読み込みエラー：',
      glucose_statistics: '血糖統計',
      image_export_requires: '画像エクスポート機能には html2canvas ライブラリが必要です',
      days: '日',
      time_sensor_active: 'センサー稼働時間：',
      healthy_glucose_range: '健康な血糖範囲：',
      below_range: '範囲未満',
      above_range: '範囲超過',
      average_glucose: '平均血糖',
      glucose_variability: '血糖変動性 (CV)',
      target_cv_message: '最適な血糖管理のための目標 CV ≤36%',
      snapshot: 'スナップショット',
      libre_view: 'LibreView',
      average_glucose_caps: '平均血糖',
      percent_above_target: '% 目標超過',
      percent_in_target: '% 目標範囲内',
      percent_below_target: '% 目標未満',
      low_glucose_events: '低血糖イベント',
      average_duration: '平均持続時間：',
      carbs: '炭水化物',
      carbohydrate_intake: '🍎 炭水化物摂取量',
      insulin: 'インスリン',
      rapid_acting_insulin: '💉 速効型インスリン',
      long_acting_insulin: '💉 持効型インスリン',
      total_daily_insulin: '📊 1日インスリン総量',
      comments: 'コメント',
      min: '分',
      no_significant_issues: 'この期間に重要な問題は検出されませんでした。',
      loading_chart: 'チャートを読み込み中...',
      error_loading_chart: 'チャートの読み込みエラー',
      time_in_range: '目標範囲内時間',
      very_high: '非常に高い (>13.9)',
      high: '高い (10.1-13.9)',
      target: '目標 (3.9-10.0)',
      low: '低い (3.0-3.8)',
      very_low: '非常に低い (<3.0)',
      unit: 'mmol/L',
      hour_abbr: '時間',
      minute_abbr: '分',
      gram_abbr: 'g',
      unit_abbr: 'u',
      summary_report: 'サマリーレポート',
      report_period: 'レポート期間',
      report_generated: 'レポート生成日時',
      sensor_coverage: 'センサーカバレッジ',
      standard_deviation: '標準偏差 (SD)',
      effective_days: '有効日数',
      data_from_continuous_monitoring: '3分間隔の連続モニタリングデータ',
      range_distribution: 'TIR（目標範囲内時間）',
      ideal_targets: '理想的な目標値',
      target_range_goal: '目標範囲内時間 ≥70%',
      low_glucose_goal: '低血糖 <4%',
      variability_goal: '変動係数 <36%',
      zoom_view: 'ズーム表示',
      zoom_chart: 'チャートズーム',
      close_zoom: 'ズームを閉じる',
      detailed_view: '詳細表示',
      summary_metrics: 'サマリー指標',
      show_events: 'イベントを表示',
      hide_events: 'イベントを非表示',
      previous_day: '前日',
      next_day: '翌日',
      duration_in_range: '範囲内の持続時間',
      zoom_tooltip: 'クリックしてこの日を拡大表示',
      before_device_start: 'デバイス起動前',
      // Dashboard Part 2 - TIR Summary
      tir_statistics: 'TIR 統計',
      target_range: '目標範囲',
      time_below_range: '目標範囲未満時間 (TBR)',
      time_above_range: '目標範囲超過時間 (TAR)',
      data_coverage: 'データカバレッジ',
      readings: '測定値',
      unit_mmol: 'mmol/L',
      time: '時刻',
      glucose: '血糖',
      // Dashboard Part 7 - Low Glucose Events
      events: 'イベント',
      showing_events_below: '閾値未満のイベントを表示',
      no_low_events: '低血糖イベントは検出されませんでした',
      no_low_events_description: 'この期間に %{threshold} %{unit} 未満の測定値はありません',
      // Loading/error states
      loading_snapshot: 'スナップショットを読み込み中...',
      error_loading_snapshot: 'スナップショットの読み込みエラー',
      loading_range_bar: '範囲バーを読み込み中...',
      error_loading_range_bar: '範囲バーの読み込みエラー',
      loading_daily_tir: '日別TIRチャートを読み込み中...',
      error_loading_daily_tir: '日別TIRチャートの読み込みエラー',
      error_loading_trend: 'チャートの読み込みエラー',
      // Chart labels
      glucose_range_distribution: '血糖範囲分布',
      time_format_note: '時刻表記：HH:MM（3分間隔の測定に基づく）',
      time_in_range_percent: '目標範囲内時間 (%)',
      glucose_overline: '血糖',
      target_range_label: '目標範囲',
      no_data_text: 'データなし',
      showing_devices: '%{count} 台のデバイスからのデータを表示',
      estimated: '（推定値）',
      y_position_estimated: '（Y軸位置は推定値）',
      view_all: 'すべて',
      // Auto-generated comments
      auto_comment_missing_insulin: 'この期間に %{days} 日間、インスリン投与の記録がありません。',
      auto_comment_no_carbs: 'この期間の炭水化物摂取データがありません。',
      auto_comment_high_low_events:
        '多数の低血糖イベント（%{count} 件）が検出されました。インスリンの調整を検討してください。',
      // SummaryReportSection metric card labels
      avg_glucose_short: '平均血糖',
      cv_short: 'CV',
      std_dev_short: '標準偏差',
      coverage_suffix: 'カバレッジ',
      // GlucoseLineChart
      error_loading_chart_detail: 'チャートの読み込みエラー：%{error}',
    },
    // Dashboard Part 3 - AGP
    agp: {
      time_of_day: '時間帯',
      title: '外来血糖プロファイル',
      percentile_bands: 'パーセンタイルバンド',
      median: '中央値 (50th)',
    },
    // Dashboard Part 3 - Vet Notes
    notes: {
      vet_notes: '獣医ノート',
      add_note: 'ノートを追加',
      save_note: 'ノートを保存',
      enter_note: '臨床ノートを入力...',
      no_notes: 'ノートはまだありません',
      add_first_note: 'このペットの最初のノートを追加',
      total_notes: '%{count} 件のノート',
      show_more: 'もっと表示',
      show_less: '折りたたむ',
      select_pet_first: 'ノートを表示するにはペットを選択してください',
      created_successfully: 'ノートを作成しました',
      error_creating: 'ノートの作成エラー',
      include_in_report: 'PDFレポートに含める',
      include_in_report_help: 'チェックを外すと内部ノートのみになります',
      internal_note: '内部',
    },
    // Dashboard Part 6 - Activities
    activities: {
      no_activities: 'アクティビティの記録がありません',
    },
    pdf: {
      generate_report: 'レポート生成',
      preparing: '準備中...',
      capturing: 'チャートをキャプチャ中...',
      generating: 'PDF生成中...',
      complete: '完了！',
      status_description: {
        preparing: 'レポートデータを準備中',
        capturing: 'チャート画像をキャプチャ中',
        generating: 'PDFドキュメントを作成中',
      },
      // Part 8: Date range picker translations
      select_date_range: 'レポートの日付範囲を選択',
      quick_presets: 'クイックプリセット',
      last_7_days: '過去7日間',
      last_14_days: '過去14日間',
      last_30_days: '過去30日間',
      last_90_days: '過去90日間',
      report_period: 'レポート期間',
      days: '日',
      pet_aggregated_notice:
        'レポートにはこのペットに関連するすべてのデバイスのデータが含まれます。',
      no_data_warning: '選択した日付範囲に利用可能な血糖データがありません。',
      actual_data_range: 'データ利用可能期間',
      use_actual_range: 'データ範囲を使用',
      checking_data: '利用可能なデータを確認しています…',
    },
    // Veterinary CGM Report translations (6-page format)
    vet_report: {
      title: 'Adapet CGM 獣医レポート',
      report_overview: 'レポート概要',
      glucose_control_summary: '血糖コントロールサマリー',
      key_findings: '主な所見',
      tir_statistics: 'TIR 統計',
      time_in_ranges: '各範囲の時間',
      target_range: '目標範囲',
      time_in_range_tir: '目標範囲内時間 (TIR)',
      time_below_range_tbr: '目標範囲未満時間 (TBR)',
      time_above_range_tar: '目標範囲超過時間 (TAR)',
      average_glucose: '平均血糖',
      data_coverage: 'データカバレッジ',
      range: '範囲',
      percent: '%',
      time: '時間',
      // Page 2: AGP
      agp: 'AGP',
      ambulatory_glucose_profile: '外来血糖プロファイル (AGP)',
      pattern_summary: 'パターンサマリー',
      time_block: '時間帯',
      median: '中央値',
      iqr: 'IQR (25-75)',
      comment: 'コメント',
      // Page 3: Glucose Trend
      glucose_trend: '血糖トレンド',
      glucose_trend_window: '血糖トレンド（レポートウィンドウ）',
      target_range_band_note:
        '目標範囲はシェーディングバンドで表示されます。一貫した解釈のため軸は固定（Y: 0-30）です。',
      notable_segments: '注目すべきセグメント＆アノテーション',
      date_time: '日時',
      type: 'タイプ',
      value: '値',
      notes_column: '備考',
      no_notable_segments: 'この期間に注目すべきセグメントは検出されませんでした。',
      // Page 4: Daily Overview
      daily_overview: '日別概要',
      daily_time_in_ranges: '日別各範囲時間',
      daily_metrics: '日別指標',
      date: '日付',
      avg: '平均',
      min_max: '最小-最大',
      tir: 'TIR',
      tar: 'TAR',
      tbr: 'TBR',
      readings: '測定数',
      activities_column: 'アクティビティ',
      // Page 5: Daily Trends
      daily_trends: '日別トレンド',
      no_daily_data: '選択した期間のデータがありません。',
      no_activities_recorded: 'アクティビティの記録なし',
      // Page 6: Events & Notes
      events_and_notes: 'イベント＆ノート',
      low_glucose_events: '低血糖イベント（閾値未満）',
      events_disclaimer:
        'イベントは設定された閾値を下回ったセンサー測定値です。臨床的な相関関係を考慮して解釈してください。',
      glucose_mmol: '血糖 (mmol/L)',
      severity: '重症度',
      no_low_events: 'この期間に低血糖イベントは検出されませんでした。',
      veterinary_assessment: '獣医評価＆計画',
      clinician: '臨床医',
      // Footer
      footer_disclaimer:
        '獣医師の確認用に生成されています。臨床的な文脈で解釈し、必要に応じて確認検査で検証してください。',
      page_of: '%{page} ページ / %{total} ページ',
    },
    common: {
      empty_data: '—',
      add_note: 'ノートを追加',
      not_available: 'N/A',
      clear: 'クリア',
    },
    owners: {
      title: 'ペットオーナー',
      total_count: '合計：%{count} 人のオーナー',
      pets_count: 'ペット',
      devices_count: 'デバイス',
      select_owner: 'オーナーを選択してペットとデバイスを表示',
    },
    leads: {
      title: 'Adapet リード 2026',
      subtitle: 'VMX、WVC、Fetch Charlotte のメール添付から統合されたイベントリードです。',
      total_records: '合計リード数',
      unique_emails: 'ユニークメール数',
      sources: 'リードソース',
      filtered_records: 'フィルター結果',
      search_placeholder: 'リード、会社、メール、役割、ソースで検索',
      all_events: 'すべてのイベント',
      empty_state: '現在のフィルターに一致するリードがありません。',
      access_denied: 'サイト管理者のみがインポートされたマーケティングリードを閲覧できます。',
    },
    shares: {
      share_created_successfully: '共有を作成しました',
      share_revoked_successfully: '共有を取り消しました',
      share_creation_failed: '一部の共有の作成に失敗しました。もう一度お試しください。',
    },
    profile: {
      title: 'プロフィール',
      profile_with_info: 'プロフィール：%{name} (ID: %{id})',
      my_profile: 'マイプロフィール',
      edit_profile: 'プロフィール編集',
      name: '氏名',
      id: 'ID',
      email: 'メールアドレス',
      phone: '電話番号',
      clinic: '動物病院',
      field_clinic_name: '動物病院名',
      field_address: '住所',
      field_postal_code: '郵便番号',
      field_city: '市区町村',
      field_state: '州 / 都道府県',
      field_country: '国',
      country_us: 'アメリカ合衆国',
      country_ca: 'カナダ',
      validation_state_invalid: '有効な州または都道府県を選択してください',
      field_short_description: '簡単な説明',
      field_full_profile: '完全なプロフィール',
      placeholder_short_description: '動物病院のサービスの簡単な説明',
      placeholder_full_profile: '獣医診療、サービス、専門分野の詳細な説明',
      not_set: '未設定',
      qr_code: 'QRコード',
      glucose_unit: '血糖単位',
      glucose_unit_mmol: 'mmol/L',
      glucose_unit_mgdl: 'mg/dL',
      validation_name_required: '氏名は必須です',
      validation_phone_invalid: '有効な電話番号を入力してください（10〜15桁）',
      validation_postal_invalid: '有効な郵便番号を入力してください',
      profile_updated: 'プロフィールを更新しました',
      profile_update_failed: 'プロフィールの更新に失敗しました',
      glucose_unit_saved: '血糖単位の設定を保存しました',
      glucose_unit_save_failed: '血糖単位の設定の保存に失敗しました',
      cancel: 'キャンセル',
      save: '保存',
      saving: '保存中...',
      print: '印刷',
      ok: 'OK',
    },
    reports: {
      export_csv: 'CSVエクスポート',
      daily_glucose_range: '日別血糖範囲',
      daily_glucose_lines: '日別血糖ライン',
      daily_glucose_histograms: '日別血糖ヒストグラム',
      combined_glucose_histogram: '統合血糖ヒストグラム',
      axis_labels: {
        glucose: '血糖',
        date: '日付',
        time_of_day: '時間帯',
        count: '件数',
      },
      chart_series: {
        daily_glucose: '日別血糖',
        daily_avg: '日別平均',
      },
      hover_labels: {
        min: '最小',
        max: '最大',
        avg: '平均',
      },
    },
    metrics: {
      filters: {
        device: 'デバイス',
        timestamp_gte: 'タイムスタンプ ≥',
        timestamp_lte: 'タイムスタンプ ≤',
        glucose_gte: '血糖 ≥',
        glucose_lte: '血糖 ≤',
      },
    },
  },
  resources: {
    customers: {
      name: '顧客 |||| 顧客',
      fields: {
        orders: '注文',
        first_seen: '初回確認',
        full_name: '氏名',
        groups: 'セグメント',
        last_seen: '最終確認',
        last_seen_gte: '訪問日以降',
        name: '氏名',
        total_spent: '合計支出',
        password: 'パスワード',
        confirm_password: 'パスワード確認',
        stateAbbr: '都道府県',
      },
      filters: {
        last_visited: '最終訪問',
        today: '今日',
        this_week: '今週',
        last_week: '先週',
        this_month: '今月',
        last_month: '先月',
        earlier: 'それ以前',
        has_ordered: '注文あり',
        has_newsletter: 'ニュースレター登録',
        group: 'セグメント',
      },
      fieldGroups: {
        identity: '個人情報',
        address: '住所',
        stats: '統計',
        history: '履歴',
        password: 'パスワード',
        change_password: 'パスワード変更',
      },
      page: {
        delete: '顧客を削除',
      },
      errors: {
        password_mismatch: 'パスワード確認がパスワードと一致しません。',
      },
      notifications: {
        created: '顧客を作成しました |||| %{smart_count} 件の顧客を作成しました',
        updated: '顧客を更新しました |||| %{smart_count} 件の顧客を更新しました',
        deleted: '顧客を削除しました |||| %{smart_count} 件の顧客を削除しました',
      },
    },
    groups: {
      name: 'グループ |||| グループ',
      fields: {
        name_helper: '獣医グループのユニークな名前を選択してください',
        description_helper: 'このグループの目的を説明してください（任意）',
      },
      notifications: {
        created: 'グループを作成しました',
        updated: 'グループを更新しました',
      },
      errors: {
        forbidden: 'この操作を実行する権限がありません',
        create_failed: 'グループの作成に失敗しました。もう一度お試しください。',
        no_create_permission:
          'グループを作成する権限がありません。獣医管理者のみがグループを作成できます。',
      },
    },
    orders: {
      name: '注文 |||| 注文',
      amount: '1 件の注文 |||| %{smart_count} 件の注文',
      title: '注文 %{reference}',
      fields: {
        basket: {
          delivery: '配送',
          reference: '参照',
          quantity: '数量',
          sum: '小計',
          tax_rate: '税率',
          taxes: '税額',
          total: '合計',
          unit_price: '単価',
        },
        address: '住所',
        customer_id: '顧客',
        date_gte: '開始日',
        date_lte: '終了日',
        nb_items: '品目数',
        total_gte: '最小金額',
        status: 'ステータス',
        returned: '返品済み',
      },
      section: {
        order: '注文',
        customer: '顧客',
        shipping_address: '配送先住所',
        items: '品目',
        total: '合計',
      },
      notifications: {
        created: '注文を作成しました |||| %{smart_count} 件の注文を作成しました',
        updated: '注文を更新しました |||| %{smart_count} 件の注文を更新しました',
        deleted: '注文を削除しました |||| %{smart_count} 件の注文を削除しました',
      },
    },
    invoices: {
      name: '請求書 |||| 請求書',
      fields: {
        date: '請求日',
        customer_id: '顧客',
        order_id: '注文',
        date_gte: '開始日',
        date_lte: '終了日',
        total_gte: '最小金額',
        address: '住所',
      },
      notifications: {
        created: '請求書を作成しました |||| %{smart_count} 件の請求書を作成しました',
        updated: '請求書を更新しました |||| %{smart_count} 件の請求書を更新しました',
        deleted: '請求書を削除しました |||| %{smart_count} 件の請求書を削除しました',
      },
    },
    products: {
      name: '商品 |||| 商品',
      fields: {
        category_id: 'カテゴリ',
        height_gte: '最小高さ',
        height_lte: '最大高さ',
        height: '高さ',
        image: '画像',
        price: '価格',
        reference: '参照',
        sales: '売上',
        stock_lte: '在庫不足',
        stock: '在庫',
        thumbnail: 'サムネイル',
        width_gte: '最小幅',
        width_lte: '最大幅',
        width: '幅',
      },
      tabs: {
        image: '画像',
        details: '詳細',
        description: '説明',
        emrs: 'カルテ',
      },
      filters: {
        categories: 'カテゴリ',
        stock: '在庫',
        no_stock: '在庫切れ',
        low_stock: '1 - 9 点',
        average_stock: '10 - 49 点',
        enough_stock: '50 点以上',
        sales: '売上',
        best_sellers: 'ベストセラー',
        average_sellers: '普通',
        low_sellers: '低い',
        never_sold: '未販売',
      },
      notifications: {
        created: '商品を作成しました |||| %{smart_count} 件の商品を作成しました',
        updated: '商品を更新しました |||| %{smart_count} 件の商品を更新しました',
        deleted: '商品を削除しました |||| %{smart_count} 件の商品を削除しました',
      },
    },
    categories: {
      name: 'カテゴリ |||| カテゴリ',
      fields: {
        products: '商品',
      },
      notifications: {
        created: 'カテゴリを作成しました |||| %{smart_count} 件のカテゴリを作成しました',
        updated: 'カテゴリを更新しました |||| %{smart_count} 件のカテゴリを更新しました',
        deleted: 'カテゴリを削除しました |||| %{smart_count} 件のカテゴリを削除しました',
      },
    },
    owners: {
      name: 'オーナー |||| オーナー',
      amount: '1 人のオーナー |||| %{smart_count} 人のオーナー',
    },
    leads: {
      name: 'リード |||| リード',
      amount: '1 件のリード |||| %{smart_count} 件のリード',
      fields: {
        event: 'イベント',
        name: 'リード',
        email: 'メール',
        company: '会社',
        role: '役職',
        location: '所在地',
        context: 'コンテキスト',
        captured_at: '取得日時',
      },
    },
    pets: {
      name: 'ペット |||| ペット',
      amount: '1 匹のペット |||| %{smart_count} 匹のペット',
      detail: 'ペット詳細',
      search_placeholder: 'ペット名 / オーナー / 品種 / 種別 / IDで検索',
      fields: {
        id: 'ID',
        name: 'ペット名',
        owner: 'オーナー',
        pet_name: 'ペット名',
        dob: '生年月日',
        birthday: '誕生日',
        created: '作成日',
        owner_email: 'オーナーメール',
        owner_website: 'オーナーウェブサイト',
        species: '種別',
        breed: '品種',
        height: '体高',
        weight: '体重',
        sex: '性別',
        color: '毛色',
        createdAt: '作成日',
        updatedAt: '更新日',
        sensor_activated: 'センサー起動日',
        vet_account: '獣医アカウント',
        vet_account_not_bound: '獣医アカウント未連携',
      },
      sex_options: {
        male: 'オス',
        female: 'メス',
        neutered_male: '去勢済みオス',
        spayed_female: '避妊済みメス',
        unknown: '不明',
      },
      action: {
        accept: '承認',
        reject: '却下',
      },
    },
    activities: {
      name: 'アクティビティ |||| アクティビティ',
      amount: '1 件のアクティビティ |||| %{smart_count} 件のアクティビティ',
      detail: 'アクティビティ詳細',
      fields: {
        id: 'ID',
        name: '名前',
        owner: 'オーナー',
        pet: 'ペット',
        pet_id: 'ペットID',
        type: 'タイプ',
        start_time: '開始時刻',
        end_time: '終了時刻',
        time: '所要時間',
        duration: '所要時間',
        description: '説明',
        created_at: '作成日時',
        updated_at: '更新日時',
      },
      insulin: {
        brand: 'ブランド',
        custom_brand: 'カスタムブランド',
        dosage: '投与量',
        units: '単位',
      },
      action: {
        accept: '承認',
        reject: '却下',
      },
    },
    devices: {
      name: 'デバイス |||| デバイス',
      amount: '1 台のデバイス |||| %{smart_count} 台のデバイス',
      detail: 'デバイス詳細',
      fields: {
        id: 'ID',
        name: '名前',
        owner: 'オーナー',
        pet: 'ペット',
        type: 'タイプ',
        start_time: '開始時刻',
        glucose_trend: '血糖トレンド',
        timezone: 'タイムゾーン',
        createdAt: '作成日',
        updatedAt: '更新日',
      },
      action: {
        accept: '承認',
        reject: '却下',
      },
    },
    metrics: {
      name: '測定値 |||| 測定値',
      amount: '1 件の測定値 |||| %{smart_count} 件の測定値',
      detail: '測定値詳細',
      fields: {
        id: 'ID',
        name: '名前',
        owner: 'オーナー',
        device: 'デバイス',
        offset: 'オフセット',
        timestamp: 'タイムスタンプ',
        glucose: '血糖',
        createdAt: '作成日時',
        updatedAt: '更新日時',
      },
      action: {
        accept: '承認',
        reject: '却下',
      },
    },
    emrs: {
      name: 'ノート |||| ノート',
      amount: '1 件のノート |||| %{smart_count} 件のノート',
      detail: 'ノート詳細',
      fields: {
        id: 'ID',
        pet: 'ペット',
        pet_id: 'ペットID',
        vet: '獣医師',
        notes: 'ノート',
        number: '#',
        author: '作成者',
        content: '内容',
        timestamp: '日付',
        date: '日付',
        created: '作成日',
        updated: '更新日',
        createdAt: '作成日',
        updatedAt: '更新日',
      },
      action: {
        accept: '承認',
        reject: '却下',
        add_note: 'ノートを追加',
      },
      notifications: {
        created: 'ノートを作成しました |||| %{smart_count} 件のノートを作成しました',
        updated: 'ノートを更新しました |||| %{smart_count} 件のノートを更新しました',
        deleted: 'ノートを削除しました |||| %{smart_count} 件のノートを削除しました',
        approved_success: 'ノートを承認しました',
        approved_error: 'エラー：ノートが承認されませんでした',
        rejected_success: 'ノートを却下しました',
        rejected_error: 'エラー：ノートが却下されませんでした',
      },
    },
    glucose: {
      axis_labels: {
        max: '最大',
        min: '最小',
        glucose: '血糖',
        date: '日付',
        time: '時刻',
      },
      hover_labels: {
        max: '最大',
        min: '最小',
      },
    },
    segments: {
      name: 'セグメント |||| セグメント',
      fields: {
        customers: '顧客',
        name: '名前',
      },
      data: {
        compulsive: '衝動型',
        collector: 'コレクター',
        ordered_once: '一度だけ注文',
        regular: '常連',
        returns: '返品',
        reviewer: 'レビュアー',
      },
    },
  },
}

export default customJapaneseMessages
